import {
  BookOpenCheck,
  Bot,
  BrainCircuit,
  ChartNoAxesCombined,
  ClipboardCheck,
  FileArchive,
  House,
  Map,
  UserRound,
  type LucideIcon,
} from 'lucide-react'
import { NavLink } from 'react-router-dom'

interface NavigationItem {
  label: string
  shortLabel?: string
  path: string
  icon: LucideIcon
}

const DESKTOP_ITEMS: readonly NavigationItem[] = [
  { label: '今日学习', path: '/today', icon: House },
  { label: '学习地图', path: '/learning-map', icon: Map },
  { label: 'AI导师', path: '/tutor', icon: Bot },
  { label: '题库与测评', path: '/assessments', icon: ClipboardCheck },
  { label: '错题复习', path: '/review', icon: BrainCircuit },
  { label: '动态资料库', path: '/materials', icon: FileArchive },
  { label: '学习报告', path: '/reports', icon: ChartNoAxesCombined },
  { label: '家长视图', path: '/parent', icon: UserRound },
] as const

const MOBILE_ITEMS: readonly NavigationItem[] = [
  { label: '今日学习', shortLabel: '今日', path: '/today', icon: House },
  { label: '学习地图', shortLabel: '地图', path: '/learning-map', icon: Map },
  { label: 'AI导师', shortLabel: 'AI导师', path: '/tutor', icon: Bot },
  { label: '错题复习', shortLabel: '错题', path: '/review', icon: BrainCircuit },
  { label: '动态资料库', shortLabel: '资料', path: '/materials', icon: FileArchive },
] as const

export function SidebarNavigation() {
  return (
    <aside className="sidebar">
      <NavLink to="/today" className="brand" aria-label="返回今日学习">
        <span className="brand__mark" aria-hidden="true">
          <BookOpenCheck size={19} strokeWidth={1.8} />
        </span>
        <span>stuDNA</span>
      </NavLink>

      <nav className="sidebar__nav" aria-label="主要导航">
        {DESKTOP_ITEMS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `nav-item ${isActive ? 'nav-item--active' : ''}`
            }
          >
            <item.icon size={19} strokeWidth={1.7} aria-hidden="true" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar__footer">
        <span className="local-dot" aria-hidden="true" />
        数据保存在当前浏览器
      </div>
    </aside>
  )
}

export function MobileNavigation() {
  return (
    <nav className="mobile-nav" aria-label="手机主要导航">
      {MOBILE_ITEMS.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            `mobile-nav__item ${isActive ? 'mobile-nav__item--active' : ''}`
          }
          aria-label={item.label}
        >
          <item.icon size={21} strokeWidth={1.8} aria-hidden="true" />
          <span>{item.shortLabel}</span>
        </NavLink>
      ))}
    </nav>
  )
}
